export const AVATAR_ACTIVITY_STATE = {
  PRESENT: 'STATE_PRESENT',
  NOT_PRESENT: 'STATE_NOT_PRESENT',
  IN_QUEUE: 'STATE_IN_QUEUE',
  DISMISSED: 'STATE_DISMISSED',
  UNKNOWN: 'STATE_UNKNOWN',
} as const;

export type AvatarActivityState =
  (typeof AVATAR_ACTIVITY_STATE)[keyof typeof AVATAR_ACTIVITY_STATE];

export interface AvatarUpdateExtensionType {
  imageUrl: string;
  name: string;
  state: AvatarActivityState;
}

export interface AvatarUpdateComponentProps {
  name: string;
  activityState: AvatarActivityState;
  extensionUniqueKey: string;
}
